//条件、6月1日以降に、発注日が含まれる。ステータスは、取消済以外
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

export const getCategoryMaster = async (categoryIds) => {
  console.log("params", categoryIds);
  try {
    let list = [];
    const chunkSize = 10;
    for (let i = 0; i < categoryIds.length; i += chunkSize) {
      const chunk = categoryIds.slice(i, i + chunkSize);
      const ordersRef = collection(db, "categories");
      const q = query(ordersRef, where("cid", "in", chunk));

      const snapshots = await getDocs(q);
      snapshots.forEach((snapshot) => {
        const data = snapshot.data();
        list.push(data);
      });
    }
    const result = list.map((category) => ({
      cid: category.cid,
      limit: category.limit,
      deduction: category.deducation,
    }));
    // カテゴリIDごとにquantityを集計する
    // 結果をオブジェクトの配列に変換

    return result; // 集計結果を返す
  } catch (error) {
    console.error("Error fetching orders:", error);
    return []; // エラー時に空リストを返す
  }
};
export default getCategoryMaster;
